'use client';

import { Button, Label, Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';
import type { SeedingSnsChannel } from '../types';

interface ContentSubmissionItem {
  channel: SeedingSnsChannel;
  label: string;
  subLabel?: string;
  /** null = row disabled (Button 미노출, onAction 호출 안됨) */
  actionLabel: string | null;
  onAction: (channel: SeedingSnsChannel) => void;
}

interface ContentSubmissionInputProps {
  /** true → "완료" Label(blueOpacity) / false → "미완료"(redOpacity) */
  isComplete: boolean;
  items: ContentSubmissionItem[];
  /** 섹션 타이틀 (default = "콘텐츠 등록") */
  title?: string;
  className?: string;
}

export const ContentSubmissionInput = ({
  isComplete,
  items,
  title = '콘텐츠 등록',
  className,
}: ContentSubmissionInputProps) => {
  // 콘텐츠 섹션은 닫히지 않으므로 완료/미완료 2상태뿐. 기한 경과해도 '미완료'(제출 가능). (QAT-39690 §2-1)
  const labelText = isComplete ? '완료' : '미완료';
  return (
    <section className={twMerge('px-[16px]!', className)}>
      <div className="pt-[12px]! pb-[11px]! flex items-center gap-[8px]">
        <Typography variant="title18pxMed" colorScheme="black">
          {title}
        </Typography>
        <Label
          variant={isComplete ? 'blueOpacity' : 'redOpacity'}
          className="rounded-sm px-[6px]! py-[2px]! text-[11px] font-medium"
        >
          {labelText}
        </Label>
      </div>
      {/* 콘텐츠 링크 제출 카드 컨테이너 — 여러 채널로 늘어날 수 있어 pt 4 / pb 12 / gap-y 8. */}
      <div className="flex flex-col gap-[8px] pt-[4px]! pb-[12px]!">
        {items.map((item) => (
          <div
            key={item.channel}
            // 카드 배경은 완료/미완료 동일하게 gray-100 (figma 63-46098 BannerNotice bgColor="gray").
            className="flex items-center justify-between rounded-[4px] bg-gray-100 px-[16px]! py-[12px]!"
          >
            {/* 카드 내부 라벨은 body13semi (figma 63-46098). */}
            <Typography variant="body13pxSemi" colorScheme="black">
              {item.label}
              {item.subLabel && (
                <Typography variant="body13pxReg" colorScheme="gray-600" asChild>
                  <span>{` ${item.subLabel}`}</span>
                </Typography>
              )}
            </Typography>
            {item.actionLabel !== null && (
              <Button
                variant="tertiaryOutlinedGray"
                size={24}
                className="shrink-0"
                onClick={() => item.onAction(item.channel)}
              >
                {item.actionLabel}
              </Button>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};
